import React from 'react'

interface PreviewProps {
  url: string
}

export const Preview: React.FC<PreviewProps> = ({ url }) => {
  return (
    <a
      id='preview-link' className='button url-action' target='_blank' data-method='get'
      href={url}
      rel='noreferrer'
    >
      PREVIEW
    </a>
  )
}
